import React, { Component, useEffect, useState } from "react";

// Utils

// Components

// Styles
import styles from "./styles";

const AxlMiniGroupAssignments = ({ indicator, text, length, children }) => {
  const [show, setShow] = useState(true);

  return (
    <div style={styles.container}>
      <div style={styles.sectionHeader} onClick={() => setShow(!show)}>
        <div style={styles.sectionName}>
          {indicator && (
            <span
              style={{
                ...styles.statusIndicator,
                ...{ backgroundColor: this.props.color },
              }}
            ></span>
          )}{" "}
          {text} ({length})
        </div>
        <div style={styles.sectionHeaderLine} />
        <div style={styles.arrow}>
          <span style={!show ? styles.arrowDown : styles.arrowUp}></span>
        </div>
      </div>
      {show && children}
    </div>
  );
};

export default AxlMiniGroupAssignments;
